<template>
  <div
    class="w-full px-4 py-2 md:py-5 lg:px-12 lg:py-0"
    :class="{
      'bg-[#102774]': $store.getters.isKlik,
      'bg-[#312782]': $store.getters.isOpenCreativesZuidwest,
      'bg-[#1D5529]': $store.getters.isOpenCreativesWaasland
    }"
    :style="{backgroundColor: !$store.getters.isKlik && !$store.getters.isOpenCreativesZuidwest && !$store.getters.isOpenCreativesWaasland ? '#102774' : ''}"
  >
    <div class="tw-flex flex-col md:flex-row md:items-center h-auto md:h-28">
      <!-- Mobile Header Bar -->
      <div class="tw-flex md:hidden items-center justify-between w-full py-2">
        <!-- Logo Section (Mobile) -->
        <router-link to="/dashboards/home" class="tw-flex items-center no-underline">
          <img
            :src="leftLogoUrl"
            :alt="config.name"
            class="max-h-8 h-auto mx-2 object-contain"
          >
        </router-link>

        <!-- Mobile Menu Toggle -->
        <button
          @click="toggleMobileMenu"
          class="tw-flex items-center justify-center w-10 h-10 text-white hover:bg-white/10 rounded transition-colors"
          :aria-label="isMobileMenuOpen ? 'Close menu' : 'Open menu'"
        >
          <svg v-if="!isMobileMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
          <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Desktop Logo Section -->
      <div class="tw-flex items-center relative lg:block hidden">
        <router-link to="/dashboards/home" class="tw-flex items-center h-16 md:h-20 no-underline">
          <img
            :src="leftLogoUrl"
            :alt="config.name"
            class="max-h-10 h-auto mx-4 object-contain max-w-[calc(100vw-100px-190px)]"
          >
        </router-link>
      </div>

      <!-- Navigation Items -->
      <div
        v-if="!$store.getters.isKlik"
        class="tw-flex items-start md:items-center relative flex-1 md:flex-row flex-col md:ml-0 transition-all duration-300 ease-in-out md:block"
        :class="{'hidden': !isMobileMenuOpen && isMobile, 'block': isMobileMenuOpen || !isMobile}"
      >
        <nav class="w-full md:w-auto">
          <ul class="tw-flex items-center md:flex-row flex-col w-full md:w-auto border-t md:border-t-0 border-white/20 pt-4 md:pt-0 mt-2 md:mt-0">
            <li>
              <router-link
                to="/actors-simplified"
                target="_self"
                class="tw-flex items-center px-4 md:px-8 py-2 md:py-0 text-white opacity-100 hover:bg-white/10 transition-colors md:h-20 h-auto w-full md:w-auto no-underline hover:underline"
                active-class="bg-white/10"
                @click="closeMobileMenu"
              >
                <span v-if="isZuidwest">De gemeenschap</span>
                <span v-else>De community</span>
              </router-link>
            </li>
            <li>
              <router-link
                to="/products-simplified"
                target="_self"
                class="tw-flex items-center px-4 md:px-8 py-2 md:py-0 text-white opacity-100 hover:bg-white/10 transition-colors md:h-20 h-auto w-full md:w-auto no-underline hover:underline"
                active-class="bg-white/10"
                @click="closeMobileMenu"
              >
                Ruimtes
              </router-link>
            </li>
            <li>
              <router-link
                to="/announcements"
                target="_self"
                class="tw-flex items-center px-4 md:px-8 py-2 md:py-0 text-white opacity-100 hover:bg-white/10 transition-colors md:h-20 h-auto w-full md:w-auto no-underline hover:underline"
                active-class="bg-white/10"
                @click="closeMobileMenu"
              >
                Kansen
              </router-link>
            </li>
            <li>
              <router-link
                to="/events-simplified"
                target="_self"
                class="tw-flex items-center px-4 md:px-8 py-2 md:py-0 text-white opacity-100 hover:bg-white/10 transition-colors md:h-20 h-auto w-full md:w-auto no-underline hover:underline"
                active-class="bg-white/10"
                @click="closeMobileMenu"
              >
                Agenda
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div v-else
           class="tw-flex items-start md:items-center relative flex-1 md:flex-row flex-col md:ml-0 transition-all duration-300 ease-in-out md:block"
           :class="{'hidden': !isMobileMenuOpen && isMobile, 'block': isMobileMenuOpen || !isMobile}"
      >
        <nav class="w-full md:w-auto">
          <ul class="tw-flex items-center md:flex-row flex-col w-full md:w-auto border-t md:border-t-0 border-white/20 pt-4 md:pt-0 mt-2 md:mt-0">
            <li class="tw-flex md:flex-row flex-col text-center items-center w-full">
              <router-link
                :to="'/spotting-areas/' + spottingArea.id"
                target="_self"
                class="tw-flex items-center text-center px-4 md:px-8 py-2 md:py-0 text-white opacity-100 hover:bg-white/10 transition-colors md:h-20 h-auto w-full md:w-auto no-underline hover:underline"
                active-class="bg-white/10"
                @click="closeMobileMenu"
                v-for="spottingArea in spottingAreas"
              >
                <span>{{ spottingArea.name }}</span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Buttons Section -->
      <div
        class="ml-0 px-0 md:ml-auto md:px-5 tw-flex flex-col md:flex-row justify-center md:justify-end mt-4 md:mt-0 transition-all duration-300 ease-in-out md:block"
        :class="{'hidden': !isMobileMenuOpen && isMobile, 'block': isMobileMenuOpen || !isMobile}"
      >
        <div class="tw-flex flex-col md:flex-row gap-2 border-t md:border-t-0 border-white/20 pt-4 md:pt-0">
          <!--          <button
                      @click="openSignupModal"
                      class="bg-transparent text-white font-normal h-auto capitalize px-4 py-2 border border-transparent hover:bg-white/10 transition-colors rounded font-secondary"
                    >
                      Registreer
                    </button>-->
          <button
            @click="goToAboutPage"
            class="bg-transparent text-white font-normal h-auto capitalize px-4 py-2 border border-transparent hover:bg-white/10 transition-colors rounded font-secondary"
          >
            Over ons
          </button>
          <button
            @click="openSigninModal"
            class="bg-transparent text-white font-normal h-auto capitalize px-4 py-2 border border-transparent hover:bg-white/10 transition-colors rounded font-secondary"
          >
            Log in
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui.js'
  import MODAL_IDS from '../../constants/modal-ids.js'
  import { trackHeapEvent } from '../../util/analytics.js'
  import { defineComponent } from 'vue'
  import SpottingAreaMixin from '@/util/SpottingAreaMixin'

  export default defineComponent({
    mixins: [SpottingAreaMixin],
    data () {
      return {
        isMobileMenuOpen: false,
        isMobile: false
      }
    },
    mounted () {
      this.checkMobile()
      window.addEventListener('resize', this.checkMobile)
    },
    beforeUnmount () {
      window.removeEventListener('resize', this.checkMobile)
    },
    methods: {
      goToAboutPage () {
        this.$router.push('/about')
      },
      checkMobile () {
        this.isMobile = window.innerWidth < 768 // md breakpoint
      },
      toggleMobileMenu () {
        this.isMobileMenuOpen = !this.isMobileMenuOpen
      },
      closeMobileMenu () {
        this.isMobileMenuOpen = false
      },
      openSigninModal () {
        this.closeMobileMenu()
        trackHeapEvent('staticHomePage.topBarLogin')
        this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.LOGIN)
      },
      openSignupModal () {
        this.closeMobileMenu()
        trackHeapEvent('staticHomePage.topBarRegister')
        if (this.$store.getters.hasAccessToEcosystemMemberPackages) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.PACKAGES_SIGN_UP)
        } else if (this.$store.state.config.allowAdd) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ACTOR_SIGN_UP)
        } else {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.SIGN_UP)
        }
      },
    },
    computed: {
      isZuidwest () {
        return this.$store.getters.isOpenCreativesZuidwest
      },
      leftLogoUrl () {
        if (this.isPnG) {
          return '/images/static-home-page/inqbet-logo.png'
        }
        return this.config.logo_url_light || this.config.logo_url
      },
      config () {
        return this.$store.state.config
      },
    },
  })
</script>

